'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _recompose = require('recompose');

var _lodash = require('lodash');

var _Slider = require('./Slider');

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var enhance = (0, _recompose.compose)((0, _recompose.withState)('values', 'setValues', function (_ref) {
	var _ref$defaultValues = _ref.defaultValues;
	var defaultValues = _ref$defaultValues === undefined ? 0 : _ref$defaultValues;
	return defaultValues;
}), (0, _recompose.withHandlers)({
	onChange: function onChange(_ref2) {
		var setValues = _ref2.setValues;
		var _ref2$onChange = _ref2.onChange;

		var _onChange = _ref2$onChange === undefined ? _lodash.noop : _ref2$onChange;

		return function (values) {
			setValues(values);
			_onChange(values);
		};
	}
}));

exports.default = enhance(_Slider2.default);